/* src/Interviews/cards/InterviewRequestsCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Paper, TextField } from '@material-ui/core';

import { PaperHeader, ApproveTable, ConfirmationPopup } from '../../../../app/components';

import { getInterviewRequests } from '../../selectors';
import { confirmInterview, declineInterview, fetchApplicant } from '../../actions';
import styles from './styles';

class InterviewRequestsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'decline',
      open: false,
      interview: '',
      reason: '',
    };

    this._onCloseResponse = this._onCloseResponse.bind(this);
    this._onOpenApprove = this._onOpenApprove.bind(this);
    this._onOpenReject = this._onOpenReject.bind(this);
    this._onConfirm = this._onConfirm.bind(this);
    this._onDecline = this._onDecline.bind(this);
    this._onRowClick = this._onRowClick.bind(this);
    this.renderDeclineContent = this.renderDeclineContent.bind(this);
    this._onChangeReasonText = this._onChangeReasonText.bind(this);

    this.popupProps = {
      confirm: {
        title: 'Confirm this Interview',
        subtitle: 'Are you sure you want to confirm this interview?',
        affirmativeButtonText: 'Confirm',
        onSubmit: this._onConfirm,
      },
      decline: {
        title: 'Decline this Interview',
        subtitle: 'Specify the reasons for your refusal',
        affirmativeButtonText: 'Decline',
        content: this.renderDeclineContent,
        onSubmit: this._onDecline,
      },
    };
  }

  _onCloseResponse() {
    this.setState({ open: false });
  }

  _onOpenApprove({ subID }) {
    this.setState({ open: true, mode: 'confirm', interview: subID });
  }

  _onOpenReject({ subID }) {
    this.setState({ open: true, mode: 'decline', interview: subID });
  }

  // TODO: can't confirm/decline if admin is not the owner of the interview
  _onConfirm() {
    const { interview } = this.state;
    this.props.confirmInterview({ interview })
      .then(() => { this._onCloseResponse(); })
      .catch(() => { this._onCloseResponse(); });
  }

  _onDecline() {
    const { interview, reason } = this.state;
    this.props.declineInterview({ interview, reason })
      .then(() => { this._onCloseResponse(); })
      .catch(() => { this._onCloseResponse(); });
  }

  _onRowClick({ user }) {
    this.props.fetchApplicant({ tutor: user._id });
  }

  _onChangeReasonText(event) {
    this.setState({ reason: event.target.value });
  }

  renderDeclineContent() {
    return (
      <TextField
        label="Reason"
        fullWidth
        onChange={this._onChangeReasonText}
        value={this.state.reason}
      />
    );
  }

  render() {
    const { classes, requests } = this.props;
    const { open, mode } = this.state;
    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <PaperHeader text="Interview Requests" />
          <ApproveTable
            data={requests}
            onApprove={this._onOpenApprove}
            onReject={this._onOpenReject}
            hover
            onRowClick={this._onRowClick}
          />
        </Paper>
        <ConfirmationPopup
          open={open}
          onClose={this._onCloseResponse}
          {...this.popupProps[mode]}
        />
      </React.Fragment>
    );
  }
}

InterviewRequestsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  requests: PropTypes.array.isRequired,
  confirmInterview: PropTypes.func.isRequired,
  declineInterview: PropTypes.func.isRequired,
  fetchApplicant: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  requests: getInterviewRequests(state),
});

const mapDispatchToProps = dispatch => ({
  confirmInterview: params => dispatch(confirmInterview(params)()),
  declineInterview: params => dispatch(declineInterview(params)()),
  fetchApplicant: params => dispatch(fetchApplicant(params)()),
});

export default compose(
  withStyles(styles, { name: 'InterviewRequestsCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(InterviewRequestsCard);



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/InterviewRequestsCard/index.js